import {relationGroupsConstants } from '../../_constants';

const initialState = { relationGroupsLoading : true, data: '', error: false};

export function relationGroupTable(state = initialState, action) {

    switch (action.type) {
      case relationGroupsConstants.REQUEST_RELATION_GROUPS:
        return {
          relationGroupsLoading: true,
          data: '',
          error: false
        };
      case relationGroupsConstants.RECEIVE_RELATION_GROUPS:

        return {
          relationGroupsLoading: false,
          data: action.relationGroups,
          error: false
        };
      case relationGroupsConstants.RELATION_GROUPS_ERROR:
        return { 
          relationGroupsLoading: false,
          data: '',
          error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/relationGroups/relationGroupsTable.reducer.js